"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBWysiwyg = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// @refresh reset
var react_1 = require("react");
var is_hotkey_1 = __importDefault(require("is-hotkey"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var slate_history_1 = require("slate-history");
var react_i18next_1 = require("react-i18next");
var SlateStyles_1 = require("./SlateStyles");
var MBWysiwygToolbar_1 = require("./MBWysiwygToolbar");
var HOTKEYS = {
    'mod+b': 'bold',
    'mod+i': 'italic',
    'mod+u': 'underline',
    'mod+`': 'code',
};
var MBWysiwyg = function (_a) {
    var _b = _a.value, value = _b === void 0 ? initialValue : _b, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var renderElement = react_1.useCallback(function (props) { return jsx_runtime_1.jsx(Element, __assign({}, props), void 0); }, []);
    var renderLeaf = react_1.useCallback(function (props) { return jsx_runtime_1.jsx(Leaf, __assign({}, props), void 0); }, []);
    var editor = react_1.useMemo(function () { return slate_history_1.withHistory(slate_react_1.withReact(slate_1.createEditor())); }, []);
    var t = react_i18next_1.useTranslation().t;
    var handleChange = function (value) {
        onChange(value);
    };
    return (jsx_runtime_1.jsx(SlateStyles_1.StyledSlate, { children: jsx_runtime_1.jsxs(slate_react_1.Slate, __assign({ editor: editor, value: value, onChange: handleChange }, { children: [jsx_runtime_1.jsx(MBWysiwygToolbar_1.MBWysiwygToolbar, {}, void 0),
                jsx_runtime_1.jsx(slate_react_1.Editable, { renderElement: renderElement, renderLeaf: renderLeaf, placeholder: t('room:personal-notes.placeholder'), spellCheck: true, autoFocus: true, onFocus: onFocus, onBlur: onBlur, onKeyDown: function (event) {
                        for (var hotkey in HOTKEYS) {
                            if (is_hotkey_1.default(hotkey, event)) {
                                event.preventDefault();
                                var mark = HOTKEYS[hotkey];
                                toggleMark(editor, mark);
                            }
                        }
                    } }, void 0)] }), void 0) }, void 0));
};
exports.MBWysiwyg = MBWysiwyg;
var toggleMark = function (editor, format) {
    var isActive = isMarkActive(editor, format);
    if (isActive) {
        slate_1.Editor.removeMark(editor, format);
    }
    else {
        slate_1.Editor.addMark(editor, format, true);
    }
};
var isMarkActive = function (editor, format) {
    var marks = slate_1.Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
var Element = function (_a) {
    var attributes = _a.attributes, children = _a.children, element = _a.element;
    switch (element.type) {
        case 'block-quote':
            return jsx_runtime_1.jsx("blockquote", __assign({}, attributes, { children: children }), void 0);
        case 'bulleted-list':
            return jsx_runtime_1.jsx("ul", __assign({}, attributes, { children: children }), void 0);
        case 'heading-one':
            return jsx_runtime_1.jsx("h1", __assign({}, attributes, { children: children }), void 0);
        case 'heading-two':
            return jsx_runtime_1.jsx("h2", __assign({}, attributes, { children: children }), void 0);
        case 'list-item':
            return jsx_runtime_1.jsx("li", __assign({}, attributes, { children: children }), void 0);
        case 'numbered-list':
            return jsx_runtime_1.jsx("ol", __assign({}, attributes, { children: children }), void 0);
        default:
            return jsx_runtime_1.jsx("p", __assign({}, attributes, { children: children }), void 0);
    }
};
var Leaf = function (_a) {
    var attributes = _a.attributes, children = _a.children, leaf = _a.leaf;
    if (leaf.bold) {
        children = jsx_runtime_1.jsx("strong", { children: children }, void 0);
    }
    if (leaf.code) {
        children = jsx_runtime_1.jsx("code", { children: children }, void 0);
    }
    if (leaf.italic) {
        children = jsx_runtime_1.jsx("em", { children: children }, void 0);
    }
    if (leaf.underline) {
        children = jsx_runtime_1.jsx("u", { children: children }, void 0);
    }
    if (leaf.mydec) {
        return (jsx_runtime_1.jsxs("span", __assign({}, attributes, { children: [jsx_runtime_1.jsx("span", __assign({ contentEditable: false }, { children: "Deco" }), void 0),
                jsx_runtime_1.jsx("b", { children: children }, void 0)] }), void 0));
    }
    return jsx_runtime_1.jsx("span", __assign({}, attributes, { children: children }), void 0);
};
var initialValue = [
    {
        type: 'paragraph',
        children: [{ text: '' }],
    },
];
//# sourceMappingURL=MBWysiwyg.js.map